import { h, Component } from 'preact'
import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import { ItemsList } from '../dropdown/interfaces'
import CreateBookmarkModal from "./CreateBookmarkModal";
import AlertComponent from "../ui-components/AlertComponent";
import tracker from "../../components/tracker/publish";

export type Bookmark = {
  id?: string
  title: string
}

export type BookmarkList = Array<Bookmark>

interface Props {}
interface State {
  bookmarks: BookmarkList | null
  selectedBookmark: Bookmark | null,
  isCreateBookmarkModalOpen: boolean,
  hasSelections: boolean
  showAlert: boolean
  error: string
}

export default class BookmarkManager extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      bookmarks: null,
      selectedBookmark: null,
      isCreateBookmarkModalOpen: false,
      hasSelections: false,
      showAlert: false,
      error: ''
    }
  }

  componentDidMount(): void {
    window.addEventListener('message', event => {
      try {
        const data = JSON.parse(event.data)
        if (data.msg === 'loadBookmarks') {
          this.setState({ bookmarks: data.bookmarks })
        }
        if (data.msg === 'loadSelections') {
          if (!data.hasSelections) {
            this.setState({ selectedBookmark: null })
          }
          this.setState({ hasSelections: data.hasSelections })
        }
      } catch (e) {}
    })
  }

  onApplyBookmark (bookmark: Bookmark) {
    const dashboardIframe: HTMLIFrameElement | null = document.querySelector('.js-qlik')
    if (dashboardIframe) {
      this.setState({ selectedBookmark: bookmark })
      dashboardIframe.contentWindow!.postMessage(JSON.stringify({
        msg: 'applyBookmark',
        bookmarkId: bookmark.id
      }), '*')
    }
  }

  onCreateBookmark (bookmark: Bookmark) {
    const { bookmarks } = this.state

    if (!bookmark.title) {
      this.setState({ error: 'Please enter a value' })
      return
    }

    const isDuplicate = bookmarks!.filter((currentBookmark: Bookmark) => bookmark.title.trim() === currentBookmark.title).length > 0

    if(isDuplicate) {
      this.setState({ error: 'A bookmark with this name has already been created'})
      return
    }

    const dashboardIframe: HTMLIFrameElement | null = document.querySelector('.js-qlik')
    if (dashboardIframe) {
      this.setState({ selectedBookmark: bookmark, isCreateBookmarkModalOpen: false, showAlert: true, error: '' })
      dashboardIframe.contentWindow!.postMessage(JSON.stringify({
        msg: 'createBookmark',
        bookmarkName: bookmark.title
      }), '*')

      tracker.trackEvent('userevent', {
        type: 'Qlik Bookmark Created',
        userName: window.inSidedData.user.name,
        userRole: window.inSidedData.user.role,
      })
    }
  }

  normalizeBookmarks (bookmarks: BookmarkList): ItemsList {
    return bookmarks.map((bookmark: Bookmark) => {
      return {
        title: bookmark.title,
        onClick: () => this.onApplyBookmark(bookmark)
      }
    })
  }

  render (_: Props, { bookmarks, selectedBookmark, isCreateBookmarkModalOpen, hasSelections, showAlert, error } : State) {
    if(!bookmarks) return null

    const DropdownText = () => {
      if (bookmarks.length === 0) return 'There are no bookmarks available'
      return selectedBookmark
        ? <div class='truncated'>
            <span>Current bookmark: </span>
            <strong>{selectedBookmark.title}</strong>
          </div>
        : 'Choose a Bookmark'
    }

    return <div class='bookmark-manager'>
      { showAlert && <AlertComponent
          messageType='success'
          message='Bookmark has been successfully created'
          isVisibleFor={3000}
          sticky
          onTimeoutEnd={() => this.setState({ showAlert: false })}
        />
      }
      {isCreateBookmarkModalOpen &&
        <CreateBookmarkModal
          onCreate={(bookmark: Bookmark) => this.onCreateBookmark(bookmark)}
          onClose={() => this.setState({ error: '', isCreateBookmarkModalOpen: false })}
          error={error}
        />
      }
        <div class='bookmark-selector-wrapper'>
          <DropdownControl
            align='adjust'
            // @ts-ignore
            trigger={<ButtonControl title={<DropdownText />} class={'bookmark-selector'} icon={'arrowDropdown'} />}
            items={this.normalizeBookmarks(bookmarks)}
            hasSearch
          />
        </div>
        { hasSelections &&
        <ButtonControl
          icon={'add'}
          class={'bookmark-create-button'}
          onClick={() => this.setState({ isCreateBookmarkModalOpen: true })}
        />
        }
    </div>
  }
}
